export const FS_SCHEME = "vscode-remote";
